import React from 'react';
import { Sparkles, Loader2 } from 'lucide-react';
import { AiReferencePicker } from './AiReferencePicker';

const GOALS = ['Hipertrofia', 'Emagrecimento', 'Força', 'Condicionamento físico', 'Saúde e qualidade de vida'];
const LEVELS = ['Iniciante', 'Intermediário', 'Avançado'];
const SEXES = ['', 'Feminino', 'Masculino'];
const MINUTES = [30, 45, 60, 75, 90];

const fieldClass =
  'w-full bg-zinc-950 border border-white/10 rounded-xl px-3 py-2.5 text-sm text-white focus:outline-none focus:border-neon-lime/60 transition-colors duration-200';

const Field = ({ label, children }) => (
  <label className="block space-y-1.5">
    <span className="text-xs uppercase tracking-wider text-zinc-500">{label}</span>
    {children}
  </label>
);

const Select = ({ value, onChange, options, testId, format = (o) => o }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} className={fieldClass} data-testid={testId}>
    {options.map((o) => (
      <option key={o} value={o}>{format(o)}</option>
    ))}
  </select>
);

export const AiWorkoutForm = ({ form, setForm, onSubmit, loading }) => {
  const set = (key) => (value) => setForm((f) => ({ ...f, [key]: value }));
  return (
    <form
      onSubmit={(e) => { e.preventDefault(); onSubmit(); }}
      className="bg-zinc-900/50 border border-white/5 rounded-2xl p-5 md:p-6 space-y-5"
      data-testid="ai-workout-form"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <Field label="Objetivo">
          <Select value={form.goal} onChange={set('goal')} options={GOALS} testId="ai-goal-select" />
        </Field>
        <Field label="Nível">
          <Select value={form.level} onChange={set('level')} options={LEVELS} testId="ai-level-select" />
        </Field>
        <Field label="Sexo (opcional)">
          <Select value={form.sex} onChange={set('sex')} options={SEXES} testId="ai-sex-select" format={(o) => o || 'Não informar'} />
        </Field>
        <Field label="Dias por semana">
          <Select value={String(form.days_per_week)} onChange={(v) => set('days_per_week')(Number(v))} options={['1', '2', '3', '4', '5', '6', '7']} testId="ai-days-select" />
        </Field>
        <Field label="Duração da sessão">
          <Select value={String(form.session_minutes)} onChange={(v) => set('session_minutes')(Number(v))} options={MINUTES.map(String)} testId="ai-minutes-select" format={(o) => `${o} min`} />
        </Field>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field label="Foco / prioridades (opcional)">
          <textarea rows={2} maxLength={300} value={form.focus} onChange={(e) => set('focus')(e.target.value)} placeholder="Ex.: glúteos e posterior, melhorar postura" className={fieldClass} data-testid="ai-focus-input" />
        </Field>
        <Field label="Restrições / lesões (opcional)">
          <textarea rows={2} maxLength={300} value={form.restrictions} onChange={(e) => set('restrictions')(e.target.value)} placeholder="Ex.: dor no joelho, evitar impacto" className={fieldClass} data-testid="ai-restrictions-input" />
        </Field>
      </div>
      <AiReferencePicker
        selectedIds={form.reference_template_ids}
        onChange={set('reference_template_ids')}
        mode={form.reference_mode}
        onModeChange={set('reference_mode')}
      />
      <button
        type="submit"
        disabled={loading}
        className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-neon-lime text-black font-bold text-sm hover:scale-[1.02] active:scale-[0.98] transition-transform duration-200 disabled:opacity-60 disabled:hover:scale-100"
        data-testid="ai-generate-btn"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
        {loading ? 'Gerando treino...' : 'Gerar treino com IA'}
      </button>
    </form>
  );
};
